import axios from 'axios'
import {
  Message
} from 'element-ui'
import S_store from './store/index.js'
//请求拦截
axios.interceptors.request.use(config => {
  return config
}, error => {
  Message({
    message: '服务器错误，请稍后再试',
    type: 'error'
  });
  return Promise.reject(error);
})
//响应拦截
axios.interceptors.response.use(config => {
  if (config.data.userid == 0 || !config.data) {
    location.href = S_store.state.ROOT_URL+"Login-login.html";
  }
  return config.data;
}, error => {
  Message({
    message: '验证过期，请重新登录',
    type: 'error'
  });
  setTimeout(() => {
    location.href = S_store.state.ROOT_URL+"Login-login.html";
  }, 1000)
  return Promise.reject(error);
})
axios.defaults.baseURL = S_store.state.ROOT_URL;



// WEBPACK FOOTER //
// ./src/http.js